import img from '../../../images/projects/Rollin_battle.png'
import { useEffect } from 'react';


import paths from '../../../config/paths'

export default function RollinBattle({ visited }) {

    useEffect(() => {
        visited();
    }, []);

    return(
        <main className="relative flex flex-col justify-evenly">
            <div className='video'>
                <img src={img}></img>
            </div>
            <h2 className='title'>Rollin' Battle</h2>
            <p className='content'>Projet d'évaluation en cours de formation demandant de pratiquer en priorité du Javascript pour créer un jeu de dés.</p>
            <p className='skills'>HTML/CSS | Bootstrap | Javascript</p>
            <div className='project-button'>
                <a className='website' target="_blank" href="https://rollinbattle.netlify.app/">Le site</a>
                <a className='github' target="_blank" href="https://github.com/Coussecousse/Rollin_battle"><i className="fa-brands fa-github"></i>Github</a>
            </div>
            <div className='project-button big-buttons'>
                <a href={paths.DES_AVENTURES} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Précédent projet</a>
                <a href={paths.PROJECTS} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Revenir aux projets</a>
                <a href={paths.MEMORY} className='backProject'>Prochain projet<i className="fa-solid fa-arrow-right ml-2"></i></a>
            </div>
        </main>
    )
}